<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button
          type="primary"
          size="medium"
          @click="supplierAddFormVisible = true"
          >新建新闻</el-button
        >
        <el-button type="info" size="medium">批量删除</el-button>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          size="medium"
          prefix-icon="el-icon-search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span class="el-icon-refresh icon-hover refresh-btn"></span>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="tableData">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="name" label="新闻标题"> </el-table-column>
      <el-table-column prop="content" label="新闻内容"> </el-table-column>
      <el-table-column prop="time" label="创建时间"> </el-table-column>
      <el-table-column label="操作" width="120">
        <template>
          <el-button type="text" @click="supplierAddFormVisible = true">编辑</el-button>
          <el-button type="text" @click="del">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination align="right"
      :current-page="1"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="400"
    >
    </el-pagination>
    <!-- 新建新闻 -->
    <el-dialog title="新建新闻" width="80%" :visible.sync="supplierAddFormVisible" center>
      <el-form
        :model="supplierAddForm"
        size="medium"
        :rules="supplierAddFormRules"
        ref="refSupplierAddForm"
        label-width="100px"
      >
        <el-form-item label="新闻标题" prop="supName">
          <el-input v-model="supplierAddForm.supName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新闻内容" prop="shortName">
          <vue-ueditor-wrap v-model="contents" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="add"
          >确 定</el-button
        >
        <el-button size="medium" @click="supplierAddFormVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  components: { VueUeditorWrap },
  data() {
    return {
      supplierAddFormVisible: false,
      tableData: [{
        id: 1,
        name: '弘扬科学精神 创造精彩人生',
        content: '首先请允许我代表学校向顺利完成学业、获得学位的2000多名硕士和博士毕业生表示热烈的祝贺和衷心的祝福。……',
        time: '2018-06-02 12:33:56'
      }, {
        id: 2,
        name: '弘扬科学精神 创造精彩人生',
        content: '首先请允许我代表学校向顺利完成学业、获得学位的2000多名硕士和博士毕业生表示热烈的祝贺和衷心的祝福。……',
        time: '2018-06-02 12:33:56'
      }],
      supplierAddForm: {
        supName: '',
        shortName: '',
        number: '',
        address: '',
        area: '',
        email: '',
        tel: '',
        user: '',
        phone: ''
      },
      supplierAddFormRules: {
        supName: [
          { required: true, message: '请输入新闻名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        shortName: [
          { required: true, message: '请输入新闻简称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      contents: '',
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 层级设置，解决在弹出窗口中下拉菜单被遮罩问题
        zIndex: 10000,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: 'http://35.201.165.105:8000/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  methods: {
    // 删除新闻
    del() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        // 删除请求待添加
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 新建新闻
    add() {
      this.$refs.refSupplierAddForm.validate(valid => {
        console.log(valid)
        if (valid) return false
      })
    }
  }
}
</script>
